import { Box, Typography } from "@mui/material";
import React from "react";
import BreadcrumbSection from "../../../components/Breadcrumb/BreadcrumbSection";
import {
  blackColor,
  blueColor04,
  errorTextColor,
} from "../../../configs/styles/muiThemes";
import { stickyHeader } from "../../../utils/styles";
import CatalogActionBtns from "../../../components/Buttons/CatalogActionBtns";
import OndcCategoryPreview from "../Preview/OndcCategoryPreview";
import VariantOndcPreview from "../Preview/VariantOndcPreview";
import ProductDetailPreview from "../Preview/ProductDetailPreview";
import SelectVariancePreview from "../Preview/SelectVariancePreview";
import VaraintProductPreview from "../Preview/VaraintProductPreview";
import OndcDataPreview from "../Preview/OndcDataPreview";

function VariantProductPreviewTab({
  title,
  titleFrom,
  links,
  onNextClick,
  onBackClick,
  categoryData,
  productInfo,
  previewData,
  ondcDetails,
  loader,
  handleCancel,
}) {
  return (
    <Box mt={{ md: 0, xs: 1 }}>
      <Box
        sx={{
          ...stickyHeader,
          display: { md: "block", xs: "none" },
          pb: 1,
        }}
      >
        <BreadcrumbSection links={links} />
        <Typography
          component="h6"
          fontSize={{ xs: 15, md: 17 }}
          color={blackColor}
          fontWeight={{ xs: 600, md: 600 }}
          lineHeight="20px"
          display="inline"
        >
          {titleFrom && <span style={{ color: blueColor04 }}>{titleFrom}</span>}
          {title}
        </Typography>
      </Box>

      <OndcCategoryPreview
        categoryData={categoryData}
        productInfo={productInfo}
      />
      <ProductDetailPreview productInfo={previewData?.productInfo} />
      <SelectVariancePreview
        variant1={previewData?.variant1}
        variant2={previewData?.variant2}
      />
      <OndcDataPreview
        ondcEnabled={ondcDetails?.ondcEnabled?.toLowerCase() == "yes"}
        timeToShip={ondcDetails?.timeToShip}
        timeUnit={ondcDetails?.timeUnit}
        cod={ondcDetails?.cod}
        fragile={ondcDetails?.fragile}
        returnable={ondcDetails?.returnable}
        returnPeriod={ondcDetails?.returnPeriod}
        sellerPickup={ondcDetails?.sellerPickup}
        cancellable={ondcDetails?.cancellable}
        refundEligible={ondcDetails?.refundEligible}
        cancellationFee={ondcDetails?.cancellationFee}
        dynamicSpecs={ondcDetails?.dynamicSpecs}
        productCode={ondcDetails?.productCode}
        productCodeValue={ondcDetails?.productCodeValue}
        unitOfMeasure={ondcDetails?.unitOfMeasure}
        unitOfMeasureValue={ondcDetails?.unitOfMeasureValue}
      />
      <VaraintProductPreview
        variantData={previewData?.variantData}
        header={previewData?.tableHeader1}
      />
      <VariantOndcPreview
        variantData={previewData?.variantData}
        header={previewData?.tableHeader2}
      />

      <Box>
        <CatalogActionBtns
          hideSaveBtn
          onNextClick={onNextClick}
          onBackClick={onBackClick}
          nextBtnText={"Submit"}
          showBackBtn
          isLoading={loader}
          onCancelClick={handleCancel}
        />
      </Box>
    </Box>
  );
}

export default VariantProductPreviewTab;
